import React from 'react';

import {api} from '../../../functions/api'

import Box from '../../../components/basic/box'
import CustomInput from '../../../components/basic/input'
import CustomButton from '../../../components/basic/CustomButton'
import Logo from '../../../components/basic/logo'

import CustomSnackbar from '../../../components/global/snackbar'

import { inject } from 'mobx-react';

const TIMEOUT = 3000;

@inject('translate')
@inject('internal')
export default class Component extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading:false,
            openSnackbar:false,
            message: ""
        }
    }

    navigateTo = () => {
        
        this.props.history.push('/');
        
    }

    handleResetPassword = () => {
        
        const emailData = this.inputEmail.getValid('email')
        if(emailData.success) {
            this.requestResetPassword();
            
        }
        else {
            this.setState({message: this.props.translate.i18n.GLOBAL.ALERTS.INCORRECT_EMAIL, openSnackbar:true})
            this.turnOffSnackBar();
        }
        
    }

    timeout = null;
    componentWillUnmount() {
        clearTimeout(this.timeout)
    }

    turnOffSnackBar = () => {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
            this.setState({
                message: "",
                openSnackbar: false
            })
        }, TIMEOUT)
    }

    requestResetPassword = async () => {
        this.setState({loading: true})
        let load_data = await api({
            method:'post',
            url:'password/request',
            params:{
                email: this.inputEmail.state.value,
            }
        })

        if(load_data.success === true) {
            this.props.internal.setSnackbar(load_data.data.message, true)
            this.navigateTo('/')
        }
        else if( load_data.success === false) {
            if(load_data.error.msg) {
                this.setState({message: load_data.error.msg, openSnackbar: true })
            }
        }
        this.setState({loading: false})
        this.turnOffSnackBar();
    }

    handleCloseSnackbar = () => {
        this.setState({ openSnackbar: false });
    };

    render() {
        return (
            

            <div className={'container-with-logo'}>
            <CustomSnackbar message={this.state.message} open={this.state.openSnackbar} onClose={this.handleCloseSnackbar}/>
                <Logo/>
                <Box>
                    <h5>Zabudli ste heslo?</h5>
                    {/* {this.props.internal.getfullName}
                    {this.props.internal.user.firstName} */}
                    
                    <CustomInput
                        text="Zadajte svoj email"
                        ref={ref => this.inputEmail = ref}
                        onPressButton={this.handleResetPassword}
                        pressedButton
                    />
                    <div className={'buttons'}>
                        <CustomButton
                            onClick={this.navigateTo}
                            mystyle={'btn-white-bg'}
                            title="Späť na prihlásenie"
                            justText
                        />
                        
                        <CustomButton
                            progressBar={this.state.loading}
                            mystyle={'btn-orange-bg'}
                            title="Resetovať heslo"
                            onClick={this.handleResetPassword}
                            justText
                            pressButton
                        />
                        
                    </div>
                </Box>
                </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/reset/request/index.js